import React, { useState, useEffect, useCallback } from "react";
import { Card, Form, Button, Select, Input, message, Spin, Space } from "antd";
import { ArrowLeftOutlined, LeftOutlined, SendOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import "./SendBusinessCardRequest.css";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import { axiosInstance, BASE_API_CONFIG } from "../../util/Api";

const SendBusinessCardRequest = () => {
  const [form] = Form.useForm();
  const history = useHistory();
  const userData = useSelector(({ auth }) => auth?.userData);
  const [exporters, setExporters] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const { isMobile } = useGetBreakpoints();

  useEffect(() => {
    fetchExporters();
  }, []);

  const fetchExporters = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`${BASE_API_CONFIG.baseURL}/business-card-request/user/exporters`);
      const formattedExporters = response.data.map((exporter) => ({
        label: exporter.companyName,
        value: exporter.id,
        searchText: exporter.companyName.toLowerCase(),
      }));
      setExporters(formattedExporters);
    } catch (error) {
      console.error("Error fetching exporters:", error);
      message.error("Failed to load exporters");
    } finally {
      setLoading(false);
    }
  };

  const onFinish = async (values) => {
    setSubmitting(true);
    try {
      await axiosInstance.post(`${BASE_API_CONFIG.baseURL}/business-card-request`, {
        exporterId: values.exporterId,
        forwarderId: userData.id,
        comments: values.comments,
      });
      message.success("Business card request sent successfully!");
      form.resetFields();
        history.push("/business-card-requests-freightforwarder");
    } catch (error) {
      console.error("Error sending request:", error);
      message.error("You already have a pending request for this exporter.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ padding: isMobile ? "12px" : "" }}>
      <Card
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div className="myexim-table-title">
              <LeftOutlined
                size="large"
                onClick={() => {
                  history.goBack();
                }}
              />{" "}
              Send Business Card Request</div>
          </div>
        }
      >
        <div style={{ marginBottom: "4px", paddingBottom: "2px" }}>
          <p style={{ color: "#1677ff" }} >Select an exporter and introduce your freight forwarding services</p>
        </div>

        <Spin spinning={loading}>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            className="business-card-form"
          >
            <Form.Item
              label="Select Exporter"
              name="exporterId"
              rules={[
                {
                  required: true,
                  message: "Please select an exporter",
                },
              ]}
            >
              <Select
                placeholder="Search and select an exporter"
                optionLabelProp="label"
                options={exporters}
                filterOption={(input, option) =>
                  option?.searchText?.toLowerCase().includes(input.toLowerCase())
                }
                showSearch
              />
            </Form.Item>

            <Form.Item
              label="Comments (Optional)"
              name="comments"
              rules={[
                {
                  max: 500,
                  message: "Comments should not exceed 500 characters",
                },
              ]}
            >
              <Input.TextArea
                placeholder="Add a message about your services, rates, or any other relevant information"
                rows={6}
                showCount
                maxLength={500}
              />
            </Form.Item>

            <Form.Item>
              <Space>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={submitting}
                  size="large"
                >
                  Send Request
                </Button>
                <Button
                  htmlType="reset"
                  size="large"
                  onClick={() => form.resetFields()}
                >
                  Clear
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Spin>
      </Card>
    </div>
  );
};

export default SendBusinessCardRequest;
